module.exports = __webpack_public_path__ + "static/media/wave-div.30675cc3.svg";